import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Layout from "../Components/Layout/Layout";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import SongTable from "./SongTable";
import { useDispatch, useSelector } from "react-redux";
import {
  addSongAsPerSection,
  getAllCategorySongs,
  getAllSongs,
} from "../Redux/Actions/songs";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { toast } from "react-toastify";

// const normalizeText = (str = "") =>
//   str.replace(/[\u2018\u2019]/g, "'").toLowerCase();

const normalizeText = (text = "") => {
  return text
    .toLowerCase()
    .trim()
    // Normalize curly apostrophes to straight
    .replace(/[‘’]/g, "'")
    // Optional: normalize quotes too
    .replace(/[“”]/g, '"')
    // Remove extra spaces
    .replace(/\s+/g, " ");
};

export default function AllSongs() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { eventId, section, page, maxsongcount } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("all");
  const [filteredSongs, setFilteredSongs] = useState([]);
  const [selectedSongs, setSelectedSongs] = useState([]);
  const [limit, setLimit] = useState(50);
  const [sortBy, setSortBy] = useState("title");
  const [sortOrder, setSortOrder] = useState("asc");
  // seperate state to hold songs for all tabs
  const [allSongs, setAllSongs] = useState([]);

  const songLists = useSelector((e) => e.songAuth.songsList);
  const allCategorySongList = useSelector((e) => e.songAuth.allCategorySongList);

  const tabs = [
    { key: "all", label: "All Genres" },
    { key: "Popular_chart", label: "Popular/Chart" },
    { key: "Classical", label: "Classical" },
    { key: "Jazz", label: "Jazz" },
    { key: "Film_tv", label: "Film/TV" },
  ];

  useEffect(() => {
    if (allCategorySongList?.songs?.length) {
      let filteredIDS = allCategorySongList?.songs.map((res) => res?._id)
      setSelectedSongs(filteredIDS)
    }
  }, [allCategorySongList])

  // Pagination function
  useEffect(() => {
    dispatch(startstopLoading(true));
    // Base fetch params
    const fetchParams = { page: currentPage, limit, sortBy, sortOrder };

    // Add Tab filters
    if (activeTab === "recomended") {
      fetchParams.recomended = true;
    } else if (activeTab !== "all") {
      fetchParams.type = activeTab;
    }
    if (search && search.trim() !== "") {
      const normalizedSearch = normalizeText(search);
      fetchParams.search = normalizedSearch;
      fetchParams.page = '0';
    }

    dispatch(getAllSongs(fetchParams)).then(() => {
      dispatch(startstopLoading(false));
    });
  }, [dispatch, activeTab, currentPage, limit, sortBy, sortOrder, search]);

  // Songs Search function
  useEffect(() => {
    const songs = songLists?.songs || [];
    let filtered = songs;

    // TAB FILTERING
    if (activeTab === "recomended") {
      filtered = songs.filter(song => song.recomended);
    } else if (activeTab !== "all") {
      filtered = songs.filter(
        song => song?.genre?.toLowerCase() === activeTab?.toLowerCase()
      );
    }

    // SEARCH FILTER
    if (search) {
      const normalizedSearch = normalizeText(search);

      console.log('====normalizedSearch', normalizedSearch);

      filtered = filtered.filter(song => {
        const titleNorm = normalizeText(song.title);

        // console.log('====titleNorm', titleNorm);

        const artistNorm = normalizeText(song.artist);

        // console.log('====artistNorm', artistNorm);

        return (
          titleNorm.includes(normalizedSearch) ||
          artistNorm.includes(normalizedSearch)
        );
      });
    }

    setFilteredSongs(filtered);
  }, [activeTab, search, songLists]);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(0);
  };

  const totalEntries = songLists?.total ?? 0;
  const entriesPerPage = 10;
  const totalPages = Math.ceil(totalEntries / limit);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // dispatch(getAllSongs({ page, limit }));
  };

  useEffect(() => {
    // if user had already selected songs
    dispatch(
      getAllCategorySongs({
        eventId: eventId,
        section: section,
        page: currentPage,
        limit: limit,
      })
    );
  }, [dispatch, currentPage, limit]);

  const handleSave = () => {
    // if (selectedSongs.length > 0) {
    const payload = {
      eventId,
      section,
      songs: selectedSongs,
    };
    dispatch(addSongAsPerSection(payload)).then((res) => {
      if (res?.payload?.statusCode == 200) {
        navigate(-1);
        toast.success("Success");
      } else {
        toast.error(res?.payload?.message);
      }
    });
    // } else {
    //   toast.error("No songs selected to save!");
    // }
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
    setCurrentPage(0);
  };

  return (
    <Layout className="main-wrap">
      <Container fluid className="mt-4 p-0 custom-boxx">
        <div className="comm-top-title-sec button-on-mobile">
          <h2>All Songs</h2>
          <div className="export-box">
            <button onClick={handleSave}>Save</button>
          </div>
        </div>

        <div className="mt-4">
          <Container fluid className="mt-4 p-0 custom-boxx">
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="all"
              onSelect={handleTabChange}
            >
              <Row>
                <Col sm={10}>
                  <div className="tab-with-search">
                    <Nav variant="pills" className="comn-tabs-set">
                      {tabs?.map((tab) => (
                        <Nav.Item key={tab.key}>
                          <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>

                    <div className="search-tab">
                      <div className="input-search">
                        <Form>
                          <Form.Group controlId="formLimitSelect">
                            <Form.Select
                              value={limit}
                              onChange={(e) => setLimit(Number(e.target.value))}
                            >
                              <option value={25}>25 per page</option>
                              <option value={50}>50 per page</option>
                            </Form.Select>
                          </Form.Group>
                        </Form>
                      </div>

                      <div className="input-search">
                        {/* <Form> */}

                        <Form.Group controlId="formBasicSearch">
                          <Form.Control
                            type="text"
                            placeholder="Search Songs"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </Form.Group>
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="8"
                            cy="8"
                            r="7"
                            stroke="#D61F7F"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M13 13L16 16"
                            stroke="#D61F7F"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                          />
                        </svg>
                        {/* </Form>  */}
                      </div>
                      <div className="export-box hide-export-mb">
                        <button onClick={handleSave}>Save</button>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col sm={10}>
                  <Tab.Content>
                    {tabs.map((tab) => (
                      <Tab.Pane eventKey={tab.key} key={tab.key}>
                        <SongTable
                          total={songLists?.total}
                          songs={filteredSongs}
                          currentPage={currentPage}
                          totalEntries={totalEntries}
                          entriesPerPage={limit}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                          setSelectedSongs={setSelectedSongs}
                          selectedSongs={selectedSongs}
                          sortBy={sortBy}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                        />
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Container>
        </div>
      </Container>
    </Layout>
  );
}
